import { css } from '@leafygreen-ui/emotion';
import { fontWeights } from '@leafygreen-ui/tokens';

export const subtitleStyles = css`
  font-size: 18px;
  line-height: 24px;
  font-weight: ${fontWeights.bold};
`;
